import React, { useState } from "react";
import styled from "styled-components";
import SaleButton from "../SaleButton";
import { colors, fonts } from "../../styles";
import { useTranslation } from "react-i18next";

export const Card = styled.div`
  width: 94%;
  max-width: 725px;
  // background: linear-gradient(254.71deg, rgba(${colors.gradDark}) 1.92%, rgba(${colors.gradLight}) 101.29%);
  background: #1b2150;
  border: 2px solid rgba(${colors.border});
  margin: 0 auto 130px;
  border-radius: 25px;
  padding: 3em;
  min-height: 490px;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    padding: 1em;
  }
`;
const SaleTitle = styled.h3`
  font-size: 32px;
  color: white;
  text-align: center;
  font-family: "Montserrat-SemiBold";
  @media (max-width: 550px) {
    font-size: 24px;
  }
`;
export const Description = styled.h5`
  font-size: 20px;
  color: #fafafa;
  opacity: 0.7;
  // font-family: 'NexaTextDemo-Light';
  margin: 1em 0;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  a {
    text-decoration: underline;
  }
`;

const SwapAmountTextField = styled.input`
  width: 170px;
  margin: 0 10px;
  color: rgb(${colors.white});
  font-size: ${fonts.size.h5};
  font-weight: ${fonts.weight.normal};

  margin-top: 8px;
  border: transparent;
  border-radius: 0;
  outline: transparent;
  background: transparent;
  border-bottom: 1px solid rgb(${colors.white});

  @media (max-width: 550px) {
    width: 70px;
    font-size: 16px;
  }
`;

const AmountSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3em;
  margin-bottom: 1em;
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;
  p {
    color: white;
  }
`;
const CoinModal = styled.div`
  // width: 92px;
  // height: 35px;
  // border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: space-around;
  img {
    width: 8px;
  }
`;

interface Props {
  currentTier: string;
  currentTierPrice: string;
  leftInTier: string;
  BV3Amount: string;
  onSendETHOnOTC: (amount: string) => Promise<boolean>;
}

const OTCInformation = (props: Props) => {
  const [amount, setAmount] = useState("");
  const { t } = useTranslation();
  const onChangeAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (e.currentTarget.value === "" || e.currentTarget.value === ".") {
        setAmount(e.currentTarget.value);
      } else if (!isNaN(Number(e.currentTarget.value))) {
        setAmount(e.currentTarget.value);
      }
    } catch (error) {}
  };

  const onSendETH = async (e: any) => {
    const result = await props.onSendETHOnOTC(amount);
    if (result) setAmount("");
  };

  return (
    <Card>
      <SaleTitle>{`${t("CurrentTier")}: ${props.currentTier}`}</SaleTitle>
      <SaleTitle>{`${t("PriceOfCurrentTier")}: $${
        props.currentTierPrice
      }`}</SaleTitle>
      <Description>
        {`${t("AmountLeftInCurrentTier")}:`} <br /> {props.leftInTier}
      </Description>
      <Description>
        {`${t("TotalAmountOfBUCCLeftInTiers")}:`} <br /> {props.BV3Amount}
      </Description>
      <AmountSection>
        <Description
          style={{ margin: "6px 0 0 0" }}
        >{`${"TradeAmount"}:`}</Description>
        <InputContainer>
          <SwapAmountTextField
            placeholder="0.00"
            value={amount}
            onChange={onChangeAmount}
          ></SwapAmountTextField>
          <CoinModal>
            <p>ETH</p>
            {/* <img src={dropdown} alt="dropdown" /> */}
          </CoinModal>
        </InputContainer>
      </AmountSection>
      {/* <Description>You get: 12 BUCC</Description> */}
      <SaleButton title={t("SwapETHToOTC")} onClick={onSendETH} />
    </Card>
  );
};

export default OTCInformation;
